import React from 'react'
import '../App.css'

export const Footer = () => {
  return (
    <>
      <footer className='footer'>
        <span>Created By Malay Thakkar | &copy; 2023 All rights reserved.
        </span>
      </footer>
    </>
  )
}

export default Footer;